import { RootPaths } from "@src/appV2/App/paths";

import { ACCOUNTS_PATH } from "../../redesign/Accounts/paths";

export const CLIPBOARD_RESUME_PATH = "clipboard-resume";
export const ACCOUNTS_CLIPBOARD_RESUME_FULL_PATH = `${RootPaths.APP_V2_HOME}/${ACCOUNTS_PATH}/${CLIPBOARD_RESUME_PATH}`;
